export const USER_SESSION_LOCALSTORAGE_KEY = 'user';
export const WORK_AS_USER_SESSION_LOCALSTORAGE_KEY = 'workAsUser';
export const WORK_AS_ENDED_KEY = 'workAsEnded';
export const USER_SSO_CONFIG_KEY = 'user-sso-config';
export const UNITY_GO_BACK_URL_KEY = 'unityGoBackUrl';
export const LOGOUT_SYNC_KEY = 'oidc-logout-sync';

export const FEDERATION_GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:token-exchange';
export const FEDERATION_REQUESTED_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:access_token';
export const FEDERATION_SUBJECT_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:id_token';
export const FEDERATION_ISSUED_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:access_token';
export const FEDERATION_TOKEN_TYPE = 'Bearer';
